module.exports = __webpack_public_path__ + "img/evangelical.e3a32a67.png";